module.exports = __webpack_public_path__ + "img/ic_phone.f45ed034.svg";